module.exports = __webpack_public_path__ + "img/MAMO-VIOLA-D-Gantry-Circular.b1ca1e79.png";